import React from 'react';
import { gikClassPrefix } from '@gik/core/constants';
import classnames from 'classnames';
import { BaseBoneProps } from '@gik/ui/SkeletonLoader/Bones/BaseBone';
import WordBone from '@gik/ui/SkeletonLoader/Bones/WordBone';
import repeatElement from '@gik/core/utils/repeatElement';

const blockName = `${gikClassPrefix}-paragraph-bone`;

export interface ParagraphBoneProps extends BaseBoneProps {
  words: number;
  minWidth?: number;
  maxWidth?: number;
}

export default function ParagraphBone({ className, words = 10, minWidth, maxWidth }: ParagraphBoneProps) {
  const blockClasses = classnames([blockName, className || '']);

  return (
    <div className={blockClasses}>{repeatElement(words, <WordBone minWidth={minWidth} maxWidth={maxWidth} />)}</div>
  );
}
